(function () {
    // reference: https://lottiefiles.com/interactivity
    // lottie-player(s) need to have unique id in block(s)
    // frames: second arg is total number of frames in animation.
    // Default is 42 set in acf field but gave some flexibility since
    // client may want to dial in animations in a little more post development
    const players = document.querySelectorAll('.js-lottie-sync-scroll');
    
    players.forEach(function (item) {
        var player_id = item.id;
        var player = document.getElementById(player_id);
        
        player.addEventListener("ready", () => {
            LottieInteractivity.create({
                mode: "scroll",
                player: "#" + player_id,
                actions: [
                    {
                        visibility: [0, 1.0],
                        type: "seek",
                        frames: [0, item.dataset.frames],
                    },
                ]
            });
        });

    });
}());